import axios from 'axios'
import $Toast from '@/plugin/LeeToast'


// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        if (res.ret !== 200) {
            $Toast({
                message: res.msg,
                type: 'error',
            })
            return Promise.reject(new Error((res.ret) || 'Error'))

        } else {
            return Promise.resolve(res);
        }
    },
    error => {
        console.log('err' + error) // for debug
        $Toast({
            message: error.msg,
            type: 'error',
        })
        return Promise.reject(error)
    }
)

//export default service

const ajax = function (obj) {
    return new Promise((resolve) => {
        service(obj)// 这里的_fetch是axios.create()创建的axios实例对象
            .then(res => {
                resolve(res)
            })
            .catch(() => {
                // console.log(err)
                // reject(err)
                // console.log(err.messagae)
                // 这里对错误啥也不干,控制台就不爆红了
            })
    })
}
export default ajax
